import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { generateReactHelmetScripts } from "../utils/helpers";
import {
  selectIsAuthenticated,
  selectProgressPercentage,
} from "../store/selectors";
import SplashPage from "./splash/SplashPage";
import TermsPage from "./terms/TermsPage";
import MainLayout from "./layout/MainLayout";
import LoginPage from "./pages/LoginPage";
import LogoutPage from "./pages/LogoutPage";
import ProgressPage from "./pages/ProgressPage";
import NotFound from "./pages/NotFound";
import { logPageView } from "../utils/appInsight";
import { trackAdobePageLoad } from "../utils/adobeLogging";
import AdminPage from "./pages/AdminPage";
import { TokenHandler } from "../HOC/TokenHandler";

const Routes = () => {
  const isAuthenticated = useSelector((state) => selectIsAuthenticated(state));
  const progressPercentage = useSelector(selectProgressPercentage);
  const progress = useSelector((state) => state.progress);
  const adobeSettings = useSelector((state) => state.adobe);
  const location = useLocation();
  const history = useHistory();
  const lang = useSelector((state) => state.ui.lang);
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (location.pathname !== currentPath) {
      logPageView(location.pathname);
      if (location.pathname !== "/progress") {
        trackAdobePageLoad({
          courseName: progress.section || null,
          progress: progressPercentage,
          language: lang
        });
      }
    }

    setCurrentPath(location.pathname);

    const allowedGuestRoutes = ["/", "/login", "/signin-oidc"];
    if (!isAuthenticated && !allowedGuestRoutes.includes(location.pathname)) {
      return history.push("/signin-oidc");
    }
  }, [isAuthenticated, location.pathname]);

  return (
    <div>
      <Helmet script={generateReactHelmetScripts(adobeSettings)} />
      <Switch>
        <Route path="/" exact>
          <SplashPage />
        </Route>
        <Route path="/terms" exact>
          <TermsPage />
        </Route>
        <Route path="/login">
          <Redirect to="/signin-oidc" />
        </Route>
        <Route path="/progress">
          {isAuthenticated && <ProgressPage /> || <Redirect to="/" />}
        </Route>
        <Route path="/signin-oidc">
          <TokenHandler />
        </Route>
        <Route path="/@dmnt33111l">
          <AdminPage />
        </Route>
        <Route path="/not-found">
          <NotFound />
        </Route>
        <Route path="/app">
          {isAuthenticated && <MainLayout /> || <Redirect to="/signin-oidc" />}
        </Route>
        <Route path="/*" render={() => history.push("/app/not-found")} />
      </Switch>
    </div>
  );
};

export default Routes;
